import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M16.232 9.35l2.498-2.666a.998.998 0 000-1.372l-2.498-2.666a1 1 0 10-1.46 1.368l.925.986H7.5c-1.324 0-2.565.654-3.455 1.545-.89.89-1.543 2.132-1.543 3.457v4a1 1 0 002 0v-4c0-.675.347-1.433.957-2.043.61-.61 1.368-.958 2.044-.96h8.19l-.92.983a1 1 0 101.459 1.368zm5.27.65a1 1 0 00-2 0v4c0 .675-.348 1.433-.957 2.043-.61.61-1.369.958-2.044.959H8.31l.923-.984a1 1 0 00-1.46-1.368l-2.498 2.666a1.002 1.002 0 000 1.372l2.498 2.666a1 1 0 101.46-1.368l-.923-.984h8.193c1.325-.001 2.566-.654 3.456-1.545.89-.89 1.543-2.132 1.543-3.457v-4z"
      />
    </svg>
  );
});
export const IconSystemV2MediaRepeat = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
